module.exports = __webpack_public_path__ + "img/story-4.fa7ed1c3.png";